<template>
  <button
    class="control-button"
    @click="emit('click')"
    :disabled="disabled"
    :aria-label="t('player.controls.previousVideo')"
    :data-tooltip="t('player.controls.previousVideo') + ' (p)'"
    v-html="skipPreviousIcon"
  />
</template>

<script setup lang="ts">
import { skipPreviousIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

defineProps<{
  disabled: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
